const KEY_PERMISSIONS = "PERMISSIONS";
const KEY_PROCESSINGPOST = "PROCESSINGPOST";

export const setUserPermissions = (permissions) => {
  localStorage.setItem(KEY_PERMISSIONS, JSON.stringify(permissions));
};


export const setUserProcessingPost = (processing) => {
  localStorage.setItem(KEY_PROCESSINGPOST, JSON.stringify(processing));
};

export const getUserPermissions = () => {
  try {
    const value = localStorage.getItem(KEY_PERMISSIONS);
    return typeof value === "string" ? JSON.parse(value) : null;
  } catch (error) {
    return null;
  }
};
export const setUserInfo = async (userInfo) => {
  localStorage.setItem("USER_INFO", JSON.stringify(userInfo));
  return true;
};

export const getUserInfo = () => {
  try {
    const value = localStorage.getItem("USER_INFO");
    if (typeof value === "string") {
      return JSON.parse(value);
    }
    return "";
  } catch (error) {
    return "";
  }
};

export const funcPost = [
  {
    label: "Danh sách tin bài",
    value: "danhsachtinbai",
  },
  {
    label: "Chuyên mục",
    value: "chuyenmuc",
  },
  {
    label: "Nguồn tin",
    value: "nguontin",
  },
  {
    label: "Bình luận",
    value: "binhluan",
  },
];

export const postStatus = [
  {
    label: "Nháp",
    value: '0'
  },
  {
    label: "Chờ duyệt",
    value: '1'
  },
  {
    label: "Cần duyệt",
    value: '2'
  },
  {
    label: "Chờ xuất bản",
    value: '3'
  },
  {
    label: "Xuất bản",
    value: '4'
  },
  {
    label: "Từ chối",
    value: '5'
  },
  {
    label: "Bị từ chối",
    value: '6'
  },
  {
    label: "Huỷ xuất bản",
    value: '7'
  },
]

export const royaltyType = [
  {
    label: "Nhuận bút tin bài",
    value: "0",
  },
  {
    label: "Nhuận bút đa phương tiện",
    value: "1",
  },
  {
    label: "Nhuận bút đăng tải",
    value: "2",
  },
  {
    label: "Kinh phí hỗ trợ",
    value: "3",
  },
];

export const questionStatus = [
  {
    label: "Chưa trả lời",
    value: "0",
    key: "NOT_ANSWERED",
  },
  {
    label: "Chờ duyệt",
    value: "1",
    key: "PENDING",
  },
  {
    label: "Đã duyệt",
    value: "2",
    key: "APPROVED",
  },
  {
    label: "Đã xuất bản",
    value: "3",
    key: "PUBLISHED",
  },
  {
    label: "Từ chối",
    value: "4",
    key: "REFUSED",
  },
  {
    label: "Chờ trả lời",
    value: "5",
    key: "WAITING_FOR_ANSWER",
  },
  {
    label: "Đã trả lời",
    value: "6",
    key: "ANSWERED",
  },
];

export const commentStatus = [
  {
    label: "Chờ duyệt",
    value: "0",
    key: "STATUS_PENDING",
  },
  {
    label: "Hiển thị",
    value: "1",
    key: "STATUS_SHOW",
  },
  {
    label: "Spam",
    value: "2",
    key: "STATUS_SPAM",
  },
  {
    label: "Spam",
    value: "3",
    key: "STATUS_DELETED",
  },
];

export const citizenScheduleStatus = [
  {
    label: "Nháp",
    value: "0",
    key: "DRAFT",
  },
  {
    label: "Chờ duyệt",
    value: "1",
    key: "PENDING",
  },
  {
    label: "Cần duyệt",
    value: "2",
    key: "NEED_APPROVE",
  },
  {
    label: "Chờ xuất bản",
    value: "3",
    key: "PENDING_PUBLISH",
  },
  {
    label: "Đã xuất bản",
    value: "4",
    key: "PUBLISHED",
  },
  {
    label: "Từ chối",
    value: "5",
    key: "REFUSE",
  },
  {
    label: "Bị từ chối",
    value: "6",
    key: "REFUSED",
  },
];

export const bannerPositions = [
  {
    label: "Đầu trang",
    value: "0",
    key: "HEAD",
  },
  {
    label: "Chân trang",
    value: "1",
    key: "FOOTER",
  },
  {
    label: "Block trái",
    value: "2",
    key: "LEFT_BANNER",
  },
  {
    label: "Block phải",
    value: "1",
    key: "RIGHT_BANNER",
  },
];

export const statusAlbum = {
  STATUS_APPROVED: "Đã duyệt",
  STATUS_PENDING: 'Chờ duyệt'

};

export const monthOfYear = [
  {
    label: "Tháng 1",
    value: 1,
  },
  {
    label: "Tháng 2",
    value: 2,
  },
  {
    label: "Tháng 3",
    value: 3,
  },
  {
    label: "Tháng 4",
    value: 4,
  },
  {
    label: "Tháng 5",
    value: 5,
  },
  {
    label: "Tháng 6",
    value: 6,
  },
  {
    label: "Tháng 7",
    value: 7,
  },
  {
    label: "Tháng 8",
    value: 8,
  },
  {
    label: "Tháng 9",
    value: 9,
  },
  {
    label: "Tháng 10",
    value: 10,
  },
  {
    label: "Tháng 11",
    value: 11,
  },
  {
    label: "Tháng 12",
    value: 12,
  },
];

export const userRole = {
  collaborators_role : 'Cộng tác viên',
  secretary_role : 'Thư ký',
  editorialDirector_role: 'Tổng biên tập',
  editorialDirector_dn_role:'Tổng biên tập đối ngoại',
  editor_role: 'Biên tập viên'
}

export const languages = {
  vietnamese: 'vi',
  english: 'en'
}

export const generateYearOptions = (startYear) => {
  const currentYear = new Date().getFullYear();
  const years = [];

  for (let i = startYear; i <= currentYear; i++) {
    years.push({
      label: i.toString(),
      value: i,
    });
  }

  return years;
};

export const positionBBT = [
  {
    key: "CHIEF",
    value: "0",
    label: "Trưởng ban",
  },
  {
    key: "DEPUTY_CHIEF",
    value: "1",
    label: "Phó Trưởng ban",
  },
  {
    key: "MEMBER",
    value: "2",
    label: "Uỷ viên",
  },
  {
    key: "SECRETARY",
    value: "3",
    label: "Thư ký",
  },
]

export const typeMediaPersonal = [
  {
    label: "Ảnh",
    value: "image",
  },
  {
    label: "Video",
    value: "video",
  },
  {
    label: "Audio",
    value: 'audio'
  },
  {
    label: "Tài liệu",
    value: "doc"
  }
]
